var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"user-select":"none"}},[_c('sf-data-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"index":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }